module.exports = __webpack_public_path__ + "static/media/study 201122.9998b559.png";